<template>
  <div>
    <v-flex
      v-for="field in attendeeFields"
      :key="field.key"
    >
      <component
        v-if="field.id !== 'Attendee name'"
        :is="field.component"
        v-model="form[field.key.split(' ').join('_')]"
        type="text"
        v-bind="field"
      />
    </v-flex>
    <v-flex
      v-if="extraModules.categoriesAndZones"
      class="pb-16"
    >
      <select-field
        v-model="form['category']"
        :items="categories"
        :label="'Category'"
        item-render="name"
        item-select="id"
      />
    </v-flex>
  </div>
</template>

<script>
const countries = require('../../../assets/countries')

export default {
  name: 'filters-modal-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    attendeeFields: {
      type: Array,
      default: () => [],
    },
    extraModules: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: { ...this.initialValues },
      countries,
    }
  },
  watch: {
    form: {
      handler(val){
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}

</script>

<style scoped>
</style>
